/* istanbul ignore file */
export const unstableFeatures = function*() {
  const url = "/api/unstable-features";
  const response = yield fetch(url, { method: "get" });
  if (response.ok) {
    const jsonResponse = yield response.json();
    return jsonResponse;
  }
  throw new Error(response.status + ": " + response.statusText);
};



// WEBPACK FOOTER //
// ./src/sc/backend/unstable-features.js